module.exports = __webpack_public_path__ + "static/img/chabanegokio.9c5bf2b.jpg";